import { Component, ViewChild, Input, Output, EventEmitter, OnInit, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';
import { DataManager } from '@syncfusion/ej2-data'
import { SelectEventArgs, ChangeEventArgs, FilteringEventArgs } from '@syncfusion/ej2-angular-dropdowns';
import { EmitType } from '@syncfusion/ej2-base';
import { HttpService } from '../../../services/http.service';
import { HelperService } from '../../../services/helper.service';
import { RequestPropTab } from '../request-prop-tab';
import { Request } from '../../../models/Request/request.model';
import { Util } from '../../../helpers/global.util';
import * as AppConst from '../../../data/test.data';
import { AuthenService } from '../../../services/authen.service';
//import { RequestMailDialogComponent } from "../../../dialogs/request-mail-dialog/request-mail-dialog";
import { forEach } from '@angular/router/src/utils/collection';
import { UrlParams } from '../../../helpers/url-params';
import { GridComponent, PageSettingsModel } from '@syncfusion/ej2-angular-grids';
import { Router } from '@angular/router';
import { objBodyMail } from '../../../models/Request/mail.model';
import { NotifyService } from '../../../services/notify.service';
import { Subscription } from 'rxjs';
//import { setTimeout } from 'timers';
import { TextBoxComponent } from '@syncfusion/ej2-angular-inputs';
import { debug } from 'util';
import { SidebarService } from '../../../sidebar/sidebar.service';

@Component({
    selector: 'detail-tab',
    templateUrl: './detail-tab.html',
    styleUrls: ['./detail-tab.css'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class DetailTabComponent extends RequestPropTab implements OnInit {
    @ViewChild('autocust') autocust: any;
    @ViewChild('automulcust') automulcust: any;
    @ViewChild('autoprn') autoprn: any;
    //@ViewChild('autoprovince') autoprovince: any;
    @ViewChild('autoapply') autoapply: any;
    @ViewChild('gridCust') gridCust: GridComponent;
    //@ViewChild('dlgSendMail') dlgSendMail: RequestMailDialogComponent;
    @Output() onChangedData = new EventEmitter<any>();

    areaList: any[] = [];    
    requestTypeList: any[] = [];
    circularTenderNew: string = null;
    requestStatusStepList: any[] = [];
    subdisList: any[] = [];
    contractFormList: any[] = [];
    requestTypeDetailList: any[] = [];
    areaOriginal: string = '';
    requestCodeOriginal: string = '';        
    viewTab: string = 'Detail';
    //requestStatusIdSelected: number = null;
    //requestTypeIdSelected: string = null;
    //requestTypeDetailIdSelected: string = null;
    //contractFormIdSelected: number = null;
    loadDetailListFirt: boolean = true;
    isViewStatusList: boolean = false;
    isSave: boolean = false;
    requireFromDate: string = null;
    requireToDate: string = null;
    requireNoOfLetter: string = null;
    requiredContractNo: string = null;
    requiredRefNo: string = null;
    requiredForm: string = null;
    requiredDetailRequest: string = null;
    selCustomer: any = null;
    gridCustData: any[] = [];
    getDataMsg: string = '';
    selCustName: string = null;
    requireSubdis: string = "";
    isHaveAttach: boolean = false;


    objMail: objBodyMail = new objBodyMail();
    //custTime = 0;
    //custText: string = null;

    dateFormat: string = 'dd/MM/yyyy';
    dateTimeFormat: string = 'dd/MM/yyyy HH:mm';
    fields: Object = { text: 'label', value: 'value' };
    nameValueFields: Object = { text: 'Name', value: 'Value' };
    nameValueNumbers: Object = { text: 'Name', value: 'Value' };

    //search customers
    data: DataManager;
    //custData: Object[] = [];
    custFields: Object = { text: 'Custname', value: 'Custcode' };    

    ////search province
    //provData: DataManager;
    //provFields: Object = { text: 'Provincename', value: 'Provincecode' };

    //search request apply
    dataApply: DataManager;
    //custData: Object[] = [];
    applyFields: Object = { text: 'Requestcode', value: 'Requestcode' };

    subsNotify: Subscription;

    public textareaObj?: TextBoxComponent;
    public createHandler(args: any): void {
        (this.textareaObj as TextBoxComponent).addAttributes({ rows: 1 } as any);
        (this.textareaObj as TextBoxComponent).element.style.height = "auto";
        (this.textareaObj as TextBoxComponent).element.style.height = ((this.textareaObj as TextBoxComponent).element.scrollHeight) + "px";
    }
    public inputHandler(args: any): void {
        (this.textareaObj as TextBoxComponent).element.style.height = "auto";
        (this.textareaObj as TextBoxComponent).element.style.height = ((this.textareaObj as TextBoxComponent).element.scrollHeight) + "px";
    }




    get AppConst() { return AppConst; }


    toggled: boolean = false;


    constructor(cdr: ChangeDetectorRef, private http: HttpService
        , private helper: HelperService
        , public auth: AuthenService
        , private router: Router, private notify: NotifyService, public sidebarService: SidebarService) {
        super(cdr);        
    }

    ngOnInit() {
  
        console.log('DetailngOnInit');
        this.loadDetailListFirt = true;
        this.isSave = true;
        //this.provData = this.http.getByListManager('api/Util/SearchProvinceMaster', this.auth);
        this.searchCustomer();
        this.loadOthers();
        this.loadDefault();
        //this.ngRefresh();


        this.sidebarService.toggled$.subscribe(val => {
            debugger;
            this.toggled = val;
        });


        
    }

    loadDefault() {
  

        if (this.requestID <= 0) {
            this.request.Idstatus = 1;
            this.loadDetailListFirt = false;
        } 
    }

    init() {
        console.log('detailinit');
        this.load();
        this.loadRequestStatusListWithStep(this.request.Idstatus);
        //this.ngRefresh();
        this.subsNotify = this.notify.getMessage().subscribe(msg => {
            if (msg.value == this.requestID.toString()) {
                if (msg.text == 'NewComments') {
                    this.helper.alertFailed('You have new message.');
                    this.countInformations();
                }
            }
        });
        this.countInformations();
    }

    ngOnDestroy() {
        if (this.subsNotify)
            this.subsNotify.unsubscribe();
    }

    load() {        
        if (this.requestID != 0) {
           
            this.searchRequestApply(this.request.Custcode);
            //console.log('Idstatus:' + this.request.Idstatus);
            //console.log('RequestTypeDetailId:' + this.request.RequestTypeDetailId);
            //console.log('Idloaiyeucau:' + this.request.Idloaiyeucau);    
            this.areaOriginal = this.request.Areaname;
            this.requestCodeOriginal = this.request.Requestcode;            
            //this.requestTypeDetailIdSelected = '';
            //this.requestTypeIdSelected = (this.request.Idloaiyeucau == null ? null : this.request.Idloaiyeucau + '');
            //this.contractFormIdSelected = null;
            //this.contractFormIdSelected = (this.request.ContractFormId == null ? null : this.request.ContractFormId);
            //this.ngRefresh();            
            this.checkRequire(this.request.Idloaiyeucau); //this.requestTypeIdSelected);
            this.http.get(`api/Util/GetRequestTypeDetailList1/${this.request.Idloaiyeucau}`, res => {
                //debugger;
                //this.requestTypeDetailIdSelected = '';
                this.requestTypeDetailList = res.Result;
                //this.requestTypeDetailIdSelected = this.request.RequestTypeDetailId + '';                
                this.loadDetailListFirt = false;
                if (this.request.Idstatus == 3 && this.auth.GroupUserCode == 'HS') {
                    this.isViewStatusList = true;
                } else if (this.request.Idstatus == 5 || this.request.Idstatus == 6) {
                    this.isViewStatusList = true;
                    if (this.auth.isSCFFM) 
                        this.isSave = false;
                    else
                        this.isSave = true;
                } else if (this.request.Idstatus > 1 && this.request.Idstatus != 3 && this.auth.GroupUserCode == 'SC') {
                    this.isViewStatusList = false;                    
                    this.isSave = false;
                } else if (((this.request.Idstatus >= 4 && this.request.Idstatus <= 6) || this.request.Idstatus==2) && this.auth.GroupUserCode == 'FFM') {
                    this.isViewStatusList = true;
                    this.isSave = false;
                }                
                this.ngRefresh();                
            }, null);            
        }        
    }
    

    loadOthers() {        
        this.http.get('api/Util/GetAreaList/', res => {
            this.areaList = res.Result;
            this.ngRefresh();
        }, null);

        this.http.get('api/Util/GetRequestTypeList1/${this.auth.LoginUser}/${this.auth.GroupUserCode}', res => {
            this.requestTypeList = res.Result;            
            //this.requestTypeIdSelected = (this.request.Idloaiyeucau == null ? null : this.request.Idloaiyeucau + '');
            this.ngRefresh();
        }, null);
        
        this.http.get('api/Util/GetSubdisList/', res => {
            this.subdisList = res.Result;                        
            this.ngRefresh();            
        }, null);        
        this.http.get('api/Util/GetContractFormList/', res => {
            this.contractFormList = res.Result;
            //this.contractFormIdSelected = null;
            //this.contractFormIdSelected = (this.request.ContractFormId == null ? null : this.request.ContractFormId);
            //console.log(this.contractFormIdSelected);
            //this.ngRefresh();
        }, null);


    }    

    onChangedCustomer: EmitType<ChangeEventArgs> = (e: any) => {        
        let cust = this.autocust.getDataByValue(e.value);
        if (cust != null) {
            this.request.Custname = cust.Custname;
            this.request.Custcode = cust.Custcode;
            this.request.UserSC = cust.UserSC;
            this.request.UserFFM = cust.UserFFM;
            this.request.Areaname = cust.Areacode;
            this.request.Provincename = cust.Provincecode;
            this.searchRequestApply(cust.Custcode);
            //this.ngRefresh();
        }
    }    

    //onChangedProvince: EmitType<ChangeEventArgs> = (e: any) => {
    //    let prov = this.autoprovince.getDataByValue(e.value);
    //    if (prov != null) {
    //        this.request.Provincename = prov.Provincecode;
    //        //this.data = this.http.getByListManager(`api/CustomerMaster/SearchCustomerMasterByName/${this.request.Area}/${this.request.Provincename}`, this.auth);
    //        this.searchCustomer();
    //    }
    //}

    searchCustomer() {
        let params = new UrlParams();
        //params.add('areaCode', this.request.Areaname, '');
        params.add('areaCode', '', '');
        //params.add('provinceCode', this.request.Provincename, '');
        params.add('provinceCode', '','');
        params.add('userName', this.auth.LoginUser, '');
        params.add('userNameInternal', this.auth.UserNameInternal, '');
        params.add('groupUserCode', this.auth.GroupUserCode, '');                
        this.data = this.http.getByListManager(`api/CustomerMaster/SearchCustomerMatrixByName/${params.toString()}`, this.auth);        
    }

    searchRequestApply(custCode: string) {
        let params = new UrlParams();
        params.add('custCode', custCode, '');        
        params.add('userName', this.auth.LoginUser, '');        
        params.add('groupUserCode', this.auth.GroupUserCode, '');
        this.dataApply = this.http.getByListManager(`api/Request/SearchRequestCodeApply/${params.toString()}`, this.auth);
    }

    onChangedArea(e) {

        if (this.isView)
            return;
        
        if (e.value != null) {
            //this.searchCustomer();                        
            if (this.isInit) {
                if (this.areaOriginal != e.value) {                    
                    this.http.get(`api/Util/GetNoInRequest/${e.value}`, res => {                        
                        this.request.Requestcode = res.Result;
                        this.ngRefresh();
                    });
                } else {
                    this.request.Requestcode = this.requestCodeOriginal;                    
                }
                //this.ngRefresh();
            }
        }
        else {
            this.request.Requestcode = '';
        }
    }

    onChangedRequestType(e) {

        if (this.isView)
            return;
        if (e.value != null) {                        
            if (this.loadDetailListFirt == false) {
                this.request.Idloaiyeucau = Number(e.value);
                this.http.get(`api/Util/GetRequestTypeDetailList1/${e.value}`, res => {
                    //console.log("lansau:" + this.requestTypeDetailIdSelected);
                    this.requestTypeDetailList = res.Result;
                    //if (this.requestTypeDetailIdSelected == '') {
                    //    this.requestTypeDetailIdSelected = (this.request.RequestTypeDetailId==null? null : this.request.RequestTypeDetailId + '');
                    //}
                    //console.log('thua:' + this.requestTypeDetailIdSelected);
                    this.ngRefresh();
                }, null);
            }
            this.checkRequire(e.value);
        }
    }

    onChangedRequestTypeDetail(e) {
        if (this.isView)
            return;
        if (e.value != null) {
            //this.request.RequestTypeDetailId = Number(e.value);
            console.log('onChangedRequestTypeDetail:' + e.value);
        }
    }

    loadRequestStatusListWithStep(statusId: number) {                                  
            this.getRequestStatusList(statusId);     
    }

    getRequestStatusList(statusId: number) {
        this.http.get(`api/Util/GetRequestStatusListWithStep/${statusId}/${this.auth.GroupUserCode}`, res => {
            this.requestStatusStepList = res.Result;
            //this.requestStatusIdSelected = this.request.Idstatus;            
            this.ngRefresh();            
        }, null);
    }

    onChangedStatus(e) {
        //console.log(e.value);
        
        if (this.isView)
            return;

        if (e.value != null)
        {
            debugger;
            this.checkValidAttachFile();
        }
        else
        {            
        }
    }

    checkRequire(strRequestTypeId: number) {
        debugger
        //console.log('checkRequire:' + strRequestTypeId);
        if (strRequestTypeId == 1 || strRequestTypeId == 0 || strRequestTypeId == 2 ||
            strRequestTypeId == 3) { //Áp giá thầu
            this.requireFromDate = 'require';
            this.requireToDate = 'require';
            this.requireNoOfLetter = 'require';
            this.requiredForm = null;
            this.requiredRefNo = null;
            this.requiredContractNo = null;
            this.requiredDetailRequest = null;
            this.requireSubdis = null;
        } else if (strRequestTypeId == 4) { //Chỉ định thầu - không hồ sơ - xin trước            
            this.requireFromDate = 'require';
            this.requireToDate = 'require';
            this.requireNoOfLetter = null;
            this.requiredForm = null;
            this.requiredRefNo = null;
            this.requiredContractNo = null;
            this.requiredDetailRequest = null;
            this.requireSubdis = null;
        } else if (strRequestTypeId == 5 || strRequestTypeId == 6) { //Chỉ định thầu - setup | Kết quả thầu - setup hoặc stop            
            this.requireFromDate = 'require';
            this.requireToDate = 'require';
            this.requireNoOfLetter = 'require';
            this.requiredForm = null;
            this.requiredRefNo = 'require';
            this.requiredContractNo = null;
            this.requiredDetailRequest = null;
            this.requireSubdis = null;
        } else if (strRequestTypeId == 7 || strRequestTypeId == 8 || strRequestTypeId == 9) { //Kết quả thầu - trước kết quả            
            this.requireFromDate = null;
            this.requireToDate = null;
            this.requireNoOfLetter = null;
            this.requiredForm = null;
            this.requiredRefNo = 'require';
            this.requiredContractNo = null;
            this.requiredDetailRequest = null;
            this.requireSubdis = null;
        } else if (strRequestTypeId == 10) { //Điều chuyển vượt quota            
            this.requireFromDate = null;
            this.requireToDate = null;
            this.requireNoOfLetter = 'require';
            this.requiredForm = null;
            this.requiredRefNo = 'require';
            this.requiredContractNo = null;
            this.requiredDetailRequest = null;
        } else if (strRequestTypeId == 11) { //Hợp đồng            
            this.requireFromDate = 'require';
            this.requireToDate = 'require';
            this.requireNoOfLetter = 'require';
            this.requiredForm = 'require';
            this.requiredRefNo = 'require';
            this.requiredContractNo = null;
            this.requiredDetailRequest = null;
            this.requireSubdis = null;
        } else if (strRequestTypeId == 12) { //Phục lục hợp đồng            
            this.requireFromDate = 'require';
            this.requireToDate = 'require';
            this.requireNoOfLetter = 'require';
            this.requiredForm = 'require';
            this.requiredRefNo = 'require';
            this.requiredContractNo = 'require';
            this.requiredDetailRequest = null;
            this.requireSubdis = null;
        } else if (strRequestTypeId == 13 || strRequestTypeId == 19) { //Thanh lý            
            this.requireFromDate = 'require';
            this.requireToDate = 'require';
            this.requireNoOfLetter = null;
            this.requiredForm = 'require';
            this.requiredRefNo = 'require';
            this.requiredContractNo = 'require';
            this.requiredDetailRequest = null;
            this.requireSubdis = null;
        } else if (strRequestTypeId == 14) { //Hợp đồng - nghiệm thu - thanh lý tháng            
            this.requireFromDate = 'require';
            this.requireToDate = 'require';
            this.requireNoOfLetter = null;
            this.requiredForm = 'require';
            this.requiredRefNo = 'require';
            this.requiredDetailRequest = null;
            this.requiredContractNo = null;
            this.requireSubdis = null;
        } else if (strRequestTypeId == 15) { //Bão lãnh            
            this.requireFromDate = 'require';
            this.requireToDate = 'require';
            this.requireNoOfLetter = 'require';
            this.requiredForm = null;
            this.requiredRefNo = 'require';
            this.requiredContractNo = null;
            this.requiredDetailRequest = null;
            this.requireSubdis = null;
        } else if (strRequestTypeId == 16 || strRequestTypeId == 17) { //Báo giá kế hoạch            
            this.requireFromDate = null;
            this.requireToDate = null;
            this.requireNoOfLetter = null;
            this.requiredForm = 'require';
            this.requiredRefNo = null;
            this.requiredContractNo = null;
            this.requiredDetailRequest = null;
            this.requireSubdis = null;
        } else if (strRequestTypeId == 24 ) { //CKTM           
            this.requireFromDate = null;
            this.requireToDate = null;
            this.requireNoOfLetter = null;
            this.requiredForm = null;
            this.requiredRefNo = 'require';
            this.requiredContractNo = 'require';
            this.requiredDetailRequest = "require";
            this.requireSubdis = "require";
        } else if (strRequestTypeId == 26 || strRequestTypeId==27) { //CKTM           
            this.requireFromDate = null;
            this.requireToDate = null;
            this.requiredForm = null;
            this.requireNoOfLetter = "require";
        }
        else {
            this.requireFromDate = null;
            this.requireToDate = null;
            this.requireNoOfLetter = null;
            this.requiredForm = null;
            this.requiredRefNo = null;
            this.requiredContractNo = null;
            this.requiredDetailRequest = null;
            this.requireSubdis = null;
        }

        this.ngRefresh();
    }

    isInputValid() {
        debugger;
        let msg = null;        
        if (this.requestID > 0)
        {
            if (Util.isFieldEmpty(this.request.Areaname))
                msg = 'Area is require';
            else if (Util.isFieldEmpty(this.request.Provincename))
                msg = 'Province is require';
            else if (Util.isFieldEmpty(this.request.Custcode))
                msg = 'Customer is require';
            else if (Util.isFieldEmpty(this.request.Requestcode))
                msg = 'Request code is require';
        }
        else
        {
            if (this.gridCustData.length <= 0) {
                msg = 'Customer is require';    
            }
                      
        }
        if (msg != null) return msg;
        if (Util.isNumberEmpty(this.request.Idloaiyeucau))
                msg = 'Request type is require';            
        if (this.request.Idloaiyeucau == 1 || this.request.Idloaiyeucau == 0 || this.request.Idloaiyeucau == 2 ||
            this.request.Idloaiyeucau == 3 ) { //Áp giá thầu
            if (Util.isDateEmpty(this.request.Fromdate))
                msg = 'Effect from date is require';
            else if (Util.isDateEmpty(this.request.Todate))
                msg = 'Effect to date is require';
            else if (!Util.isValidDateTimeFromTo(new Date(this.request.Fromdate), new Date(this.request.Todate))) 
                msg = 'Effect to should be greater than Effect from';
            else if (Util.isFieldEmpty(this.request.SoCV))
                msg = 'No of letter is require';            
        } else if (this.request.Idloaiyeucau == 4) { //Chỉ định thầu - không hồ sơ - xin trước
            if (Util.isDateEmpty(this.request.Fromdate))
                msg = 'Effect from date is require';
            else if (Util.isDateEmpty(this.request.Todate))
                msg = 'Effect to date is require';
            else if (!Util.isValidDateTimeFromTo(new Date(this.request.Fromdate), new Date(this.request.Todate)))
                msg = 'Effect to should be greater than Effect from';
        } else if (this.request.Idloaiyeucau == 5 || this.request.Idloaiyeucau == 6) { //Chỉ định thầu - setup | Kết quả thầu - setup hoặc stop
            if (Util.isFieldEmpty(this.request.Sorefnothamchieu))
                msg = 'RefNo is require.';
            else if (Util.isDateEmpty(this.request.Fromdate))
                msg = 'Effect from date is require';
            else if (Util.isDateEmpty(this.request.Todate))
                msg = 'Effect to date is require';
            else if (!Util.isValidDateTimeFromTo(new Date(this.request.Fromdate), new Date(this.request.Todate)))
                msg = 'Effect to should be greater than Effect from';
            else if (Util.isFieldEmpty(this.request.SoCV)) 
                msg = 'No of letter is require';            
        } else if (this.request.Idloaiyeucau == 7 || this.request.Idloaiyeucau == 8 || this.request.Idloaiyeucau == 9) { //Kết quả thầu - trước kết quả
            if (Util.isFieldEmpty(this.request.Sorefnothamchieu))
                msg = 'RefNo is require.';
        } else if (this.request.Idloaiyeucau == 10) { //Điều chuyển vượt quota
            if (Util.isFieldEmpty(this.request.Sorefnothamchieu))
                msg = 'RefNo is require.';
            else if (Util.isFieldEmpty(this.request.SoCV))
                msg = 'No of letter is require';
        } else if (this.request.Idloaiyeucau == 11) { //Hợp đồng
            if (Util.isFieldEmpty(this.request.Sorefnothamchieu))
                msg = 'RefNo is require.';
            else if (Util.isDateEmpty(this.request.Fromdate))
                msg = 'Effect from date is require';
            else if (Util.isDateEmpty(this.request.Todate))
                msg = 'Effect to date is require';
            else if (!Util.isValidDateTimeFromTo(new Date(this.request.Fromdate), new Date(this.request.Todate)))
                msg = 'Effect to should be greater than Effect from';
            else if (Util.isFieldEmpty(this.request.SoCV))
                msg = 'No of letter is require';
            else if (Util.isNumberEmpty(this.request.ContractFormId) || this.request.ContractFormId == 4)
                msg = 'Form is require';
        } else if (this.request.Idloaiyeucau == 12) { //Phục lục hợp đồng
            if (Util.isFieldEmpty(this.request.Sorefnothamchieu))
                msg = 'RefNo is require.';
            else if (Util.isDateEmpty(this.request.Fromdate))
                msg = 'Effect from date is require';
            else if (Util.isDateEmpty(this.request.Todate))
                msg = 'Effect to date is require';
            else if (!Util.isValidDateTimeFromTo(new Date(this.request.Fromdate), new Date(this.request.Todate)))
                msg = 'Effect to should be greater than Effect from';
            else if (Util.isFieldEmpty(this.request.SoCV))
                msg = 'No of letter is require';
            else if (Util.isNumberEmpty(this.request.ContractFormId) || this.request.ContractFormId == 4)
                msg = 'Form is require';
            else if (Util.isFieldEmpty(this.request.Sohopdong))
                msg = 'Contract no is require';
        } else if (this.request.Idloaiyeucau == 13 || this.request.Idloaiyeucau == 19) { //Thanh lý
            if (Util.isFieldEmpty(this.request.Sorefnothamchieu))
                msg = 'RefNo is require.';
            else if (Util.isDateEmpty(this.request.Fromdate))
                msg = 'Effect from date is require';
            else if (Util.isDateEmpty(this.request.Todate))
                msg = 'Effect to date is require';
            else if (!Util.isValidDateTimeFromTo(new Date(this.request.Fromdate), new Date(this.request.Todate)))
                msg = 'Effect to should be greater than Effect from';            
            else if (Util.isNumberEmpty(this.request.ContractFormId) || this.request.ContractFormId == 4)
                msg = 'Form is require';
            else if (Util.isFieldEmpty(this.request.Sohopdong))
                msg = 'Contract no is require';
        } else if (this.request.Idloaiyeucau == 14) { //Hợp đồng - nghiệm thu - thanh lý tháng
            if (Util.isFieldEmpty(this.request.Sorefnothamchieu))
                msg = 'RefNo is require.';
            else if (Util.isDateEmpty(this.request.Fromdate))
                msg = 'Effect from date is require';
            else if (Util.isDateEmpty(this.request.Todate))
                msg = 'Effect to date is require';
            else if (!Util.isValidDateTimeFromTo(new Date(this.request.Fromdate), new Date(this.request.Todate)))
                msg = 'Effect to should be greater than Effect from';
            else if (Util.isNumberEmpty(this.request.ContractFormId) || this.request.ContractFormId == 4)
                msg = 'Form is require';            
        } else if (this.request.Idloaiyeucau == 15) { //Bão lãnh
            if (Util.isFieldEmpty(this.request.Sorefnothamchieu))
                msg = 'RefNo is require.';
            else if (Util.isDateEmpty(this.request.Fromdate))
                msg = 'Effect from date is require';
            else if (Util.isDateEmpty(this.request.Todate))
                msg = 'Effect to date is require';
            else if (!Util.isValidDateTimeFromTo(new Date(this.request.Fromdate), new Date(this.request.Todate)))
                msg = 'Effect to should be greater than Effect from';
            else if (Util.isFieldEmpty(this.request.SoCV))
                msg = 'No of letter is require'
        } else if (this.request.Idloaiyeucau == 24) { //CKTM
            if (Util.isFieldEmpty(this.request.Sorefnothamchieu))
                msg = 'RefNo is require.';
            else if (Util.isFieldEmpty(this.request.Sohopdong))
                msg = 'Contract no is require'
            else if (Util.isFieldEmpty(this.request.Subdistcode))
                msg = 'Subdist is require'
        }
        else if (this.request.Idloaiyeucau == 16 || this.request.Idloaiyeucau == 17) { //Báo giá kế hoạch
            if (Util.isNumberEmpty(this.request.ContractFormId) || this.request.ContractFormId == 4)
                msg = 'Form is require';
        } else if (this.request.Idloaiyeucau == 26 || this.request.Idloaiyeucau == 27) { 
            if (Util.isFieldEmpty(this.request.SoCV))
                msg = 'No of letter is require';
        }
        // nghia add require subdis
        if (Util.isFieldEmpty(this.request.Subdistcode)) {
            msg = 'Subdist is require';
        }

        return msg;
    }

    onSave() {

        let err = this.isInputValid();
        
        if (this.request.Idloaiyeucau == 24 && this.request.Idstatus == 2 && this.isHaveAttach == false) {
            err = "Loại CKTM cần file đình kèm";
        }


        if (err == null) {

  
            if (this.request.ID == 0) {
      
                this.request.Grouprename = this.auth.GroupUserCode;                
            }

            if (this.requestID > 0)
            {

                this.http.saveSilent('api/Request/Save', this.request, res => {
           
                    this.request.ID = res.ID;
                    this.requestID = res.ID;
                    this.helper.alert('Save success');
                    this.onChangedData.emit({ 'Msg': 'SetEditMode' }); //this will reload page so must call after send mail
                    this.load();
                    this.loadRequestStatusListWithStep(this.request.Idstatus);
                    this.http.get('api/Request/Get/' + res.ID, res => {
                        this.request.set(res.Result);
                        this.onSendMail();
                        this.ngRefresh();

                    }, null);
                    
                }, null);
            } else {
       
                let cnt = this.gridCustData == null ? 0 : this.gridCustData.length;
                this.request.CustObjectList = this.gridCustData;
                if (cnt > 1) {
                    this.request.FromRequestCode = null;
                }
                this.http.saveSilent('api/Request/SaveMultiRequest', this.request, res => {                    
                    this.getDataMsg = `${cnt} customers updated success`;                    
                    this.gridCustData = [];
                    this.selCustName = '';
                    if (cnt == 1) {
                        this.request.ID = res.ID;
                        this.requestID = res.ID;
                        this.load();
                        this.loadRequestStatusListWithStep(this.request.Idstatus);
                        this.http.get('api/Request/Get/' + res.ID, res => {
                            this.request.set(res.Result);
                            this.helper.alert('Save success');
                            this.onChangedData.emit({ 'Msg': 'SetEditMode' }); //this will reload page so must call after send mail
                            this.onSendMail();
                            this.ngRefresh();



                        }, null);
                    } else {
                        this.router.navigate(['/requests-all']);
                    }
                    //this.router.navigate(['/request-prop', this.request.ID, this.request.Requestcode, 1, 0]);
                    
                });                
            }
        }
        else {
            this.helper.alertFailed(err);
        }
    }

    onCopy() {
        this.http.saveSilent('api/Request/Copy', this.request, res => {            
            this.requestID = res.LongID;
            this.requestCode = res.RequestCode;
            this.helper.alert('Copy success');
            if (this.requestID > 0) {                
                this.router.navigate(['/request-prop/' + this.requestID + '/' + this.requestCode + '/1/external/' + this.iPathCode]);
                this.http.get('api/Request/Get/' + this.requestID, res => {
                    this.isSave = true;
                    this.request.set(res.Result);
                    this.init();
                    this.ngRefresh();
                }, null);                
            }
        });
    }


    onSelectedCustomer(evt: any) {
        this.selCustomer = this.automulcust.getDataByValue(evt.value);

        if (this.selCustomer) {
            if (this.gridCustData.find(p => p.Custcode == this.selCustomer.Custcode) == null) {
                this.searchRequestApply(this.selCustomer.Custcode);
                this.gridCustData.push(this.selCustomer);                
                this.gridCust.refresh();                
            }
        }
    }

    getCustCode() {
        if (this.selCustomer)
            return this.selCustomer.Custcode;
        return '';
    }



    onRemoveCustomer(cust: any) {
        this.helper.confirm(`Are you sure you want to remove customer ${cust.Custcode} ?`, () => {
            let index = this.gridCustData.findIndex(p => p.Custcode == cust.Custcode);            

            if (index !== -1) {
                this.gridCustData.splice(index, 1);
                this.gridCust.refresh();
            }
        });
    }

    onSendMail() {
        let Subject = '';        
        let toUser = '';
        let ccUser = '';
        if (this.request.Idstatus == 9) {
            Subject = 'Waiting approval-' + this.request.Requestcode + '-' + this.request.RequestTypeName;
            toUser = this.request.UserFFM;
            ccUser = this.request.UserSC;            
        } else if (this.request.Idstatus == 2) {
            Subject = 'FFM approval-Done-' + this.request.Requestcode + '-' + this.request.RequestTypeName;
            toUser = this.request.UserFFM;
            ccUser = this.request.UserFFM;
                       
        } else if (this.request.Idstatus == 4) {
            Subject = 'Inprogress-' + this.request.Requestcode + '-' + this.request.RequestTypeName;
            toUser = this.request.UserSC;
            ccUser = this.request.UserFFM;
           

        } else if (this.request.Idstatus == 3) {
            Subject = 'Return-' + this.request.Requestcode + '-' + this.request.RequestTypeName;
            toUser = this.request.UserSC;
            ccUser = this.request.UserFFM;
        } else if (this.request.Idstatus == 5) {
            Subject = 'Done-' + this.request.Requestcode + '-' + this.request.RequestTypeName;
            toUser = this.request.UserSC;
            ccUser = this.request.UserFFM;
          
        }


       

        let paramObj =
        {
            RequestID : this.requestID,
            RequestCode : this.request.Requestcode,
            Subject : Subject,
            ToUser : toUser,
            CcUser : ccUser,
            RequestTypeName: this.request.RequestTypeName,
            UserNameInternal: this.request.UserSC,
            DeadlineFFMApproval: this.request.DeadlineFFMApproval,
            DeadlineHSChecking: this.request.DeadlineHScheck,
            DeadlineHSDone: this.request.DeadlineHDdone,
            UrlAddr: window.location.href,
            OtherContent: null
        };
        this.objMail.set(paramObj);
        if (this.request.Idstatus == 9) {
            this.http.post(`api/Util/SendOpenToApproval/`, this.objMail, res => {
                this.helper.alert('Send mail FFM approval success');
            });
        } else if (this.request.Idstatus == 2) {
            this.http.post(`api/Util/SendApprovalToChecking/`, this.objMail, res => {
                this.helper.alert('Send mail HS checking success');
            });
        } else if (this.request.Idstatus == 4) {
            this.http.post(`api/Util/SendCheckingToInprogress/`, this.objMail, res => {
                this.helper.alert('Send mail HS inprogress success');
            });
        } else if (this.request.Idstatus == 3) {
            this.http.post(`api/Util/SendCheckingToReturn/`, this.objMail, res => {
                this.helper.alert('Send mail return success');
            });
        } else if (this.request.Idstatus == 5) {
            this.http.post(`api/Util/SendInProgressToDone/`, this.objMail, res => {
                this.helper.alert('Send mail done success');
            });
        }
    }

    countInformations(): void {
        console.log('countInformations:' + this.requestID);
        this.http.get('api/Request/GetComment/' + this.requestID, res => {
            let comments: Array < any > =[];
             comments = res.Result;
            this.onChangedData.emit({ 'Msg': 'CountMessage','CountValue' : comments.length});
        }, null);
    }



    onBackToList() {

        //var objSearch = JSON.parse(this.filterSearch);
        //if (objSearch != null && objSearch.Route != null)
        //{
        //    this.router.navigate([objSearch.Route]);
        //}
        //else {
        //    this.router.navigate(["/request-search-all"]);
        //}
        
    }


    checkValidAttachFile() {

        if (!Util.isFieldEmpty(this.request.Requestcode)) {
            this.http.get(`api/LinkFile/GetRequestDocList/${this.request.Requestcode}/ZPV`, res => {
    
                let numAttach = res.Result.length;
                this.isHaveAttach = (numAttach > 0 ? true : false);
            });

        } else {
            return true;
        }
    }

   

    

}
